import Vue from 'vue';

Vue.directive('dynamicPlaceholder', {
  inserted(el, binding) {
    if (!binding.value) {
      return console.error('No configuration for dynamic placeholder.');
    }

    // Workaround, if not directly applied to an input, but to a wrapped input (component)
    const domElement =
      el.nodeName === 'INPUT'
        ? el
        : el.querySelector(
            'input[type="search"], input[type="text"], input[type="email"]'
          );
    if (!domElement) {
      return console.error(
        'Unable to find element to apply dynamic placeholder'
      );
    }

    const prefix = binding.value.prefix.trim() || '';
    let typeSpeed = binding.value.typeSpeed || 500;
    let waitTime = binding.value.waitTime || 2000;
    let deleteSpeed = binding.value.deleteSpeed || 80;
    let terms = binding.value.terms || [];
    let index = 0;

    domElement.placeholder = prefix;
    (function rotateSearchTerm() {
      const currentTerm = terms[index];
      let i = 0;
      let interval = setInterval(() => {
        domElement.placeholder = prefix + ' ' + currentTerm.slice(0, i);
        i++;
        if (i > currentTerm.length) {
          clearInterval(interval);
          setTimeout(() => {
            interval = setInterval(() => {
              domElement.placeholder = prefix + ' ' + currentTerm.slice(0, i);
              i--;
              if (i < 0) {
                clearInterval(interval);
                index = (index + 1) % terms.length;
                setTimeout(rotateSearchTerm, waitTime);
              }
            }, deleteSpeed);
          }, waitTime);
        }
      }, typeSpeed);
    })();
  }
});
